import React from 'react'
import { Outlet } from 'react-router-dom';

const SimpleLayout = () => {
  return (
    <div style={{background:'#D3D3D3'}}>
        <Outlet />
    </div>
  )
}

export default SimpleLayout